<template>
  <div class="banner_component"
       :style="{'background': 'url('+bannerData.banner+')',backgroundRepeat:'no-repeat', backgroundPosition:'center center', backgroundSize: 'cover'}">
    <div class="banner_title">
      <p>{{bannerData.cnTitle}}</p>
      <p>{{bannerData.enTitle}}</p>
    </div>

  </div>
</template>

<script>
  export default {
     props:{
       bannerData:Object
     },
    data() {
      return {
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .banner_component {
    width: 100%;
    height: 280px;
    margin-top: 20px;
    display: flex;
    justify-content: center;
    .banner_title {
      width: 1200px;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      color: #fff;
      p:first-of-type {
        font-size: 40px;
      }
      p:last-of-type {
        margin-top: 10px;
        font-size: 24px;
      }
    }
  }
</style>
